var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$parent.$parent.rerender)?_c('div',{staticClass:"row myrow content-mb-42"},[_c('div',{staticClass:"col-xs-12 mycol",class:{
      'has-error': _vm.$parent.$parent.checkErrorField(
        'PROJECTS',
        'LOGIC',
        'UF_MAIN_MAIN_MANUFACTURERS_ABROAD'
      )
    }},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.$parent.project.UF_MAIN_MAIN_MANUFACTURERS_ABROAD),expression:"$parent.project.UF_MAIN_MAIN_MANUFACTURERS_ABROAD"}],staticClass:"i-main-style t-dop-style i-wid-50",staticStyle:{"height":"72px"},attrs:{"disabled":_vm.$parent.$parent.projectDisabled,"placeholder":""},domProps:{"value":(_vm.$parent.project.UF_MAIN_MAIN_MANUFACTURERS_ABROAD)},on:{"keyup":function($event){return _vm.$parent.$parent.removeError(
          'PROJECTS',
          'LOGIC',
          'UF_MAIN_MAIN_MANUFACTURERS_ABROAD'
        )},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.$parent.project, "UF_MAIN_MAIN_MANUFACTURERS_ABROAD", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"error-text"},[_vm._v("\n      "+_vm._s(_vm.$parent.$parent.checkErrorText(
          "PROJECTS",
          "LOGIC",
          "UF_MAIN_MAIN_MANUFACTURERS_ABROAD"
        ))+"\n    ")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }